<div class="attention-channels" #attentionChannels data-section-id="attention-channels-section" data-section-name="Attention Channels">
  <app-container class="attention-channels__container">
    <div class="attention-channels__header">
      <h2 class="attention-channels__title">¿Tienes alguna duda o necesitas comunicarte con nosotros?</h2>
    </div>

    <div class="attention-channels__card">
      <!-- Temporalmente comentamos la imagen hasta tenerla disponible -->
      <div class="attention-channels__image-container">
        <img
          src="https://www.unipay.cl/api/descargaArchivo/web-whatsapp02.gif"
          alt="Unipay WhatsApp"
          class="attention-channels__image"
        />
      </div>

      <div class="attention-channels__content">
        <!-- Temporalmente comentamos la imagen móvil hasta tenerla disponible -->
        <!-- <div class="attention-channels__mobile-image">
          <img
            src="assets/images/imagen-WSP.png"
            alt="Unipay WhatsApp"
            class="attention-channels__mobile-img"
          />
        </div> -->

        <h3 class="attention-channels__content-title">Con Unipay en Whatsapp todo es más simple</h3>
        <ul class="attention-channels__list">
          <li class="attention-channels__item">
            <span class="attention-channels__bullet"></span>
            <span>Simula y pide Avances o Súper Avances</span>
          </li>
          <li class="attention-channels__item">
            <span class="attention-channels__bullet"></span>
            <span>Pide una copia de tu Estado de Cuenta</span>
          </li>
          <li class="attention-channels__item">
            <span class="attention-channels__bullet"></span>
            <span>Controla tus movimientos</span>
          </li>
          <li class="attention-channels__item">
            <span class="attention-channels__bullet"></span>
            <span>Paga fácil y accede a más opciones</span>
          </li>
        </ul>
        <div class="phone-block">

          <span class="phone-number">+56 9 5812 3297</span>
        <a
          href="https://wa.me/56958123297"
          class="attention-channels__button"
          target="_blank"
          rel="noopener noreferrer"
          (click)="onWhatsAppClick()"
        >
          Ir a Whatsapp
        </a>

        </div>
        
      </div>
    </div>
  </app-container>
</div>
